import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import mqttClient from '../../api/mqtt.js';
import useAuth from '../../auth_services/useAuth';

// ==============================|| MINIMAL LAYOUT ||============================== //
// use for login page

const MinimalLayout = () => {
    // Mqtt broker listen
    const [mqttMessage, setMqttMessage] = useState([]);
    useEffect(() => {
        mqttClient.on('connect', () => {
            mqttClient.subscribe('salePaymentSuccess');
            mqttClient.subscribe('packagePaymentSuccess');
        });
        mqttClient.on('message', (topic, message) => {
            //console.log('topic, message', topic, message.toString());
            let message1 = message.toString();
            let message2 = JSON.parse(message1);
            let data = message2.val;

            //console.log('data.mid == useAuth.mid() --->>>', data.mid, ' == ', useAuth.mid());
            if (data.mid == useAuth.mid()) {
                // Sale payment
                let action = '';
                if (topic == 'salePaymentSuccess') {
                    action = 'salePaymentSuccess';
                }
                // Package payment
                else if (topic == 'packagePaymentSuccess') {
                    action = 'packagePaymentSuccess'
                }

                setMqttMessage({
                    action: action,
                    val: data
                });

                // Set sms count to localStorage
                let count = 0;
                if (localStorage.getItem("smscount") != undefined && localStorage.getItem("smscount") != null) {
                    let smsCount = JSON.parse(localStorage.getItem("smscount"));
                    count = parseInt(smsCount.count + 1);
                }
                let sms = {
                    mid: useAuth.mid(),
                    count: count
                }
                localStorage.setItem("smscount", JSON.stringify(sms));
            }

        });

        mqttClient.on('error', (err) => {
            console.error('Connection error: ', err);
        });

        mqttClient.on('close', (close) => {
            console.error('Connection close: ', close);
        });

        return () => {
            //mqttClient.end();
        };

    }, []);
    return (
        <>
            <Outlet context={{ mqttMessage }} />
        </>
    )
};

export default MinimalLayout;
